import { createContext, useContext } from 'react';

export type FieldContextType = {
  'aria-describedby'?: string;
  id: string;
  invalid: boolean;
};

export const FieldContext = createContext<FieldContextType | null>(null);

export function useFieldContext() {
  const ctx = useContext(FieldContext);

  if (!ctx) {
    throw new Error('Input components must be inside a `Field`.');
  }

  return ctx;
}
